import type z from '@/lib/zod';
import { toLegacySubTab } from '@/lib/helpers/list-tabs';
import { MCP_CLIENTS_TABS } from '@/pages/mcp-clients/lib/mcp-clients-filters';
import { commonSearchSchema } from './commonSearchSchema';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from './search-param-schemas';

export const mcpClientsSearchSchema = commonSearchSchema
  .extend({
    /** Tab della tabella (come la webapp). */
    subTab: optionalSearchString(),
    /**
     * Link di prima con lo stato attivo: diventa `subTab` e non esce dallo
     * schema. Da rimuovere dopo il 2026-12-31.
     */
    isActive: optionalSearchBoolean(),
    /** Filtro «Verifica» del popover. */
    verified: optionalSearchBoolean(),
  })
  .transform(({ isActive, ...search }) => ({
    ...search,
    subTab: toLegacySubTab({
      tabs: MCP_CLIENTS_TABS,
      subTab: search.subTab,
      legacyFilter: isActive,
    }),
  }));

export type McpClientsSearch = z.output<typeof mcpClientsSearchSchema>;
